import {
  OAUTH_APP_STORAGE_PREFIX,
  OAUTH_PENDING_STORAGE_KEY,
  getOAuthRedirectUri,
} from '../data/oauthProvidersMeta';

export function createOAuthState() {
  const arr = new Uint8Array(16);
  if (typeof crypto !== 'undefined' && crypto.getRandomValues) {
    crypto.getRandomValues(arr);
  } else {
    for (let i = 0; i < arr.length; i += 1) arr[i] = Math.floor(Math.random() * 256);
  }
  return Array.from(arr, (b) => b.toString(16).padStart(2, '0')).join('');
}

export function loadOAuthAppDraft(providerId) {
  try {
    const raw = localStorage.getItem(`${OAUTH_APP_STORAGE_PREFIX}${providerId}`);
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
}

export function saveOAuthAppDraft(providerId, { clientId, name, scopesText }) {
  try {
    localStorage.setItem(
      `${OAUTH_APP_STORAGE_PREFIX}${providerId}`,
      JSON.stringify({ clientId: clientId || '', name: name || '', scopesText: scopesText || '' }),
    );
  } catch {
    /* ignore quota errors */
  }
}

export function clearOAuthAppDraft(providerId) {
  try {
    localStorage.removeItem(`${OAUTH_APP_STORAGE_PREFIX}${providerId}`);
  } catch {
    /* ignore */
  }
}

export function saveOAuthPending(payload) {
  sessionStorage.setItem(OAUTH_PENDING_STORAGE_KEY, JSON.stringify({
    ...payload,
    redirectUri: getOAuthRedirectUri(),
    createdAt: Date.now(),
  }));
}

export function loadOAuthPending() {
  try {
    const raw = sessionStorage.getItem(OAUTH_PENDING_STORAGE_KEY);
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
}

export function clearOAuthPending() {
  sessionStorage.removeItem(OAUTH_PENDING_STORAGE_KEY);
}
